import { call } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import axiosServices from '../../../services/axiosServicesLocais';
import { Response } from '../../../interfaces/index';
import store from '../..';
import {
  setLocaisAction, requestFailure, setLoading, setLoadingById, setLocalById, setCleanLocalScreen,
} from './actions';

export function* getLocais() {
  try {
    const response: Response = yield call(axiosServices.get, 'admin/locais/v1');
    store.dispatch(
      setLocaisAction(response.data.data),
    );
  } catch (err: any) {
    if (err.status === 500) {
      store.dispatch(requestFailure(JSON.stringify(err.data)));
    } else {
      toast.error(`⚠ ${err?.response.data?.notifications?.map((item: any) => `${item.message}\n`) || err?.data.message}`);
      store.dispatch(requestFailure(JSON.stringify(err.data)));
    }
  }
}

export function* createLocal({ payload }: any) {
  try {
    store.dispatch(setLoading(true));
    yield call(axiosServices.post, 'admin/locais/v1', payload);
    toast.success('Salvo com sucesso!');
    store.dispatch(setLoading(false));
    store.dispatch(setCleanLocalScreen(true));
    store.dispatch({ type: 'SET_SUCCESS', payload: true });
  } catch (err: any) {
    if (err.status === 500) {
      store.dispatch(setLoading(false));
    } else {
      store.dispatch(setLoading(false));
      toast.error(`⚠ ${err?.response.data?.notifications?.map((item: any) => `${item.message}\n`)}`);
      store.dispatch(requestFailure(JSON.stringify(err.data)));
    }
  }
}

export function* updateLocal({ payload }: any) {
  try {
    const { id, payload: data } = payload;
    store.dispatch(setLoading(true));
    yield call(axiosServices.put, `admin/locais/v1/${id}`, data);
    toast.success('Atualizado com sucesso!');
    store.dispatch(setLoading(false));
  } catch (err: any) {
    if (err.status === 500) {
      store.dispatch(setLoading(false));
    } else {
      store.dispatch(setLoading(false));
      toast.error(`⚠ ${err?.response.data?.notifications?.map((item: any) => `${item.message}\n`)}`);
      store.dispatch(requestFailure(JSON.stringify(err.data)));
    }
  }
}

export function* getLocalById({ payload }: any) {
  try {
    store.dispatch(setLoadingById(true));
    const response: Response = yield call(axiosServices.get, `admin/locais/v1/${payload}`);
    store.dispatch(setLoadingById(false));
    store.dispatch(setLocalById(response.data.data));
  } catch (err: any) {
    if (err.status === 500) {
      store.dispatch(setLoadingById(false));
    } else {
      store.dispatch(setLoadingById(false));
      toast.error(`⚠ ${err?.response.data?.notifications?.map((item: any) => `${item.message}\n`)}`);
      store.dispatch(requestFailure(JSON.stringify(err.data)));
    }
  }
}
